module.exports = __webpack_public_path__ + "static/CodeCup4-ba05a91c9f16fb2146a6c4eaf482eb47.jpg";